import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { stats, company } from "../mock";

const useCountUp = (target, active) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    const num = parseInt(target.replace(/[^\d]/g, ""), 10) || 0;
    const duration = 1400;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.floor(eased * num));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, active]);
  return val.toLocaleString();
};

const StatItem = ({ stat, active }) => {
  const display = useCountUp(stat.value, active);
  return (
    <div className="text-center">
      <div className="font-display font-extrabold text-white text-4xl md:text-5xl">
        {display}
        <span className="text-brand-orange">{stat.suffix}</span>
      </div>
      <p className="text-white/70 mt-2 text-sm md:text-base">{stat.label}</p>
    </div>
  );
};

const Stats = () => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setActive(true),
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative bg-brand-slate py-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-brand-navy to-brand-slate" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid sm:grid-cols-3 gap-10 mb-10">
          {stats.map((s, i) => (
            <StatItem key={i} stat={s} active={active} />
          ))}
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 border-t border-white/10 pt-10">
          <p className="text-white text-lg font-display font-semibold text-center">
            No matter the situation, Fab Build Pro has your back —{" "}
            <span className="text-brand-orange">100% Price Match.</span>
          </p>
          <a
            href={company.phoneHref}
            className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangedark text-white font-semibold px-6 py-3 rounded-full shadow-md transition-colors shrink-0"
          >
            <Phone className="w-5 h-5" /> {company.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Stats;
